export const LANGUAGE_CODE = {
    ENGLISH: "en",
    FRANCE: "fr"
}